// https://nuxt.com/docs/api/configuration/nuxt-config
export default defineAppConfig({
	cmsstaticcontent: {previewTimeoutMs: 60000},
	fetchApi: {catalogProductsTimeout: 10000},
	baseCompatibility: '151',
	eventWeb: {
		enabled: true,
		collectMode: false,
		couponEventsEnabled: false,
	},
	cache: {
		debug: false,
		refresh: {
			currency: 1440, // 24 hours
			endpoints: 1440,
			info: 1440,
			labels: 10,
			menus: 30,
			redirects: 60,
			rotators: 10,
			routes: 5,
			token: 1440,
			newsletter: 1440,
			gdprTemplate: 1440,
			thumbs: 180,
			cmsPages: 30,
			catalogCategories: 5,
			catalogLists: 5,
			catalogManufacturers: 30,
			catalogProducts: 5,
			catalogProduct: 5,
			catalogSellers: 5,
			faqCategories: 60,
			faqQuestions: 60,
			faqQuestion: 60,
			publishCategories: 60,
			publishPost: 30,
			publishPosts: 30,
			locationPoints: 60,
			staticContent: 15,
			cmsStaticContent: 15,
		},		
	},
	hapiEndpoints: {
		'_post_hapi_sweepstake_participant_validate': '/hapi/latest/sweepstake/participant-validate/',
		'_get_hapi_cmsstaticcontent_pages': '/hapi/latest/cmsstaticcontent/pages/',
		'_post_hapi_cmsstaticcontent_pages': '/hapi/latest/cmsstaticcontent/pages/',
	},
	meta: [
		{name: 'robots', content: 'max-snippet:-1, max-image-preview:large, max-video-preview:-1'},
		{name: 'msapplication-TileColor', content: '#0050a0'},
		{name: 'theme-color', content: '#0050a0'},
	],
	hooks: {
		checkAccess: data => {
			// Redirect to category if product is not accessible
			if (data.controller == 'catalog' && data.action == 'detail') {
				const categoryParents = data.data?.category_parents?.length ? data.data.category_parents : [];
				const categoryParent = categoryParents?.length ? categoryParents[categoryParents.length - 1] : null;
				if (categoryParent) {
					return {
						redirectTo: categoryParent.url_without_domain,
					};
				}
			}
			
			if(data.controller == 'catalog' && data.contentType == 'list'){
				return {
					template: 'Error404',
				};
			}
		},
	},
	webshop: {
		steps: ['customer', 'shipping', 'reviewOrder'],
	},
	catalog: {
		productsResponseFields: [
			'additional_product_variants_count',
			'active_shipping_options_count',
			'short_description',
			'attributes_special',
			'energy_class',
			'energy_image_upload_path',
			'element_information_list_comment_1',
			'element_information_list_comment_2',
			'element_information_list_comment_3',
			'availability_info',
			'available_qty',
			'badges',
			'promotions',
			'basic_price_custom',
			'category_title',
			'category_code',
			'manufacturer_title',
			'category_url_without_domain',
			'category_hierarchy_parents',
			'code',
			'date_available',
			'discount_percent_custom',
			'extra_price_cart_dynamicprice',
			'extra_price_dynamicprice',
			'extra_price_mode_dynamicprice',
			'feedback_comment_widget',
			'feedback_rate_widget',
			'id',
			'installments_list_data',
			'installments_calculation',
			'is_available',
			'is_rate',
			'last_piece_sale',
			'loyalty_price_custom',
			'main_image_description',
			'images',
			'image',
			'main_image_title',
			'main_image_upload_path',
			'main_image_thumbs',
			'all_images',
			'other_images',
			'price_custom',
			'product_condition',
			'element_state_code',
			'quantity',
			'selected_price',
			'seller_id',
			'seller_title',
			'seller_code',
			'seller_url_product_page_without_domain',
			'seller_url_without_domain',
			'shipping_date',
			'shipping_options',
			'shopping_cart_code',
			'status',
			'title',
			'type',
			'url_without_domain',
			'warehouses_single_pickup_display',
			'xxx',
		],
		thumbsResponseFields: {
			"catalogproductfile-file": ['width400-height400', 'width110-height110'],
		},		
		fetch: {
			check_lists: 'webcatalog_cs-fm,webcatalog_cs-lb,webcatalog_cs-lt,webcatalog_3d-ar',
			appconfig: 'product_pim_min_chars',
		},
		hooks: {
			mapProduct: product => {
				if (product?.type == 'configurable' && product?.initial_offer) {
					return product.initial_offer;
				}
				return product;
			},
		},
		urls: {
			hr: {
				items: 'proizvodi',
				item: 'p',
			},
			ba: {
				items: 'proizvodi',
				item: 'p',
			},
		},	
		redirectUnavailableProduct: {url: '/'},
	},
	staticcontent: {
		thumbsResponseFields: {
			'landing_banner': {
				'image': [],
				'image2': [],
			},
			'landing_brands': {
				'image': [],
				'image2': [],
			},
			'landing_categories': {
				'image': [],
			},
			'landing_categories_slider': {
				'image': [],
			},
			'landing_coupon': {
				'image': [],
			},
			'landing_image_left_light': {
				'image': [],
			},
			'landing_image_right_dark': {
				'image': [],
			},
			'landing_image_center_black': {
				'image': [],
			},
			'landing_image_center_white': {
				'image': [],
			},
			'landing_image_left_black': {
				'image': [],
			},
			'landing_image_left_white': {
				'image': [],
			},
			'landing_image_right_black': {
				'image': [],
			},
			'landing_image_right_white': {
				'image': [],
			},
			'landing_intro': {
				'image': [],
				'image2': [],
			},
			'landing_item_promo2_btn_blue': {
				'image': [],
			},
			'landing_item_promo3_btn_blue': {
				'image': [],
			},
			'landing_item_promo3_btn_white': {
				'image': [],
			},
			'landing_item_promo4_btn_blue': {
				'image': [],
			},
			'landing_item_promo4_btn_white': {
				'image': [],
			},
			'landing_item_promo5_btn_blue': {
				'image': [],
			},
			'landing_item_promo5_btn_white': {
				'image': [],
			},
			'landing_item_promo6_btn_blue': {
				'image': [],
			},
			'landing_item_promo6_btn_white': {
				'image': [],
			},
			'landing_product': {
				'main_image': ['width400-height400'],
			},
			'landing_product_double': {
				'main_image': ['width400-height400'],
			},
			'landing_product_list': {
				'main_image': ['width400-height400'],
				'image': ['width110-height110'],
			},
			'landing_products_multirow': {
				'main_image': ['width400-height400'],
			},
			'landing_products_slider': {
				'main_image': ['width400-height400'],
			},
			'landing_promo_big': {
				'image': [],
			},
			'landing_promo_medium': {
				'image': [],
				'image2': [],
			},
			'landing_promo_row_left': {
				'image': [],
				'image2': [],
			},
			'landing_promo_small': {
				'image': [],
				'image2': [],
			},
			'landing_publish': {
				'image': [],
				'image2': [],
			},
		},
	},	
	google: {
		gtm: {
			env: ['production', 'development'],
			code: process.env.NODE_ENV == 'development' ? 'GTM-52222222222222222222222222222222' : 'GTM-5F34ZXDL',
		},
	},
	compare: {
		limit: 4,
	},
	keycloak: true,
	auth: {
		loggedOutRedirect: 'home',
		returnContext: {
			enabled: true,
		},
	},
	structuredData: {
		enabled: true,
	},
	productsSwiperConfig: {
		slidesPerView: 1.5,
		slidesPerGroup: 1,
		spaceBetween: 12,
		breakpoints: {
			1100: {
				spaceBetween: 24,
				slidesPerView: 5,
				slidesPerGroup: 5,
			},
			800: {
				spaceBetween: 24,
				slidesPerView: 3.5,
				slidesPerGroup: 4,
			},
			600: {
				slidesPerView: 2.5,
				slidesPerGroup: 2,
			}
		}
	},
	thumbPresets: {
		page: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1440,
						height: 530,
						crop: true,
					},
				},
			],
		},
		heroSlider: {
			imageFields: ['image_upload_path', 'image_4_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1920,
						height: 440,
						crop: true,
					},
					related: ['image_upload_path']
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 960,
						height: 676,
						crop: true,
					},
					related: ['image_4_upload_path']
				}
			],
		},
		seller: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 200,
						height: 200,
						crop: false,
					},
				}
			],
		},
		catalogEntry: {
			imageFields: ['other_images.file', 'all_images.file'],
			thumbs: [
				{
					alias: 'thumb_small',
					config: {
						width: 110,
						height: 110,
						crop: false,
					},
					related: ['other_images.file', 'all_images.file']
				},
			],
		},
		catalogPromo: {
			imageFields: ['image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 275,
						height: 490,
						crop: true,
					},
				},
			],
		},
		addToCartModal: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 240,
						height: 240,
						crop: false,
					},
				},
			],
		},		
		catalogList: {
			imageFields: ['main_image_3'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 403,
						height: 715,
						crop: true,
					},
				},
			],
		},
		categories: {
			imageFields: ['image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 200,
						height: 200,
						crop: false,
					},
				}
			],
		},
		catalogDetail: {
			imageFields: ['all_images.file'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 640,
						height: 640,
						crop: false,
					},
				},
				{
					alias: 'thumb_small',
					config: {
						width: 110,
						height: 110,
						crop: false,
					},
				},
				{
					alias: 'thumb_zoom',
					config: {
						width: 1000,
						height: 1000,
						crop: false,
					},
				},
			],
		},
		catalogEnergy: {
			imageFields: ['url', 'all_images.file', 'energy_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb_energy',
					config: {
						width: 60,
						height: 60,
						crop: false,
					},
				},
				{
					alias: 'thumb_energy_gallery',
					config: {
						width: 800,
						height: 800,
						crop: false,
					},
				},
			],
		},
		promoCategory: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1480,
						height: 540,
						crop: false,
					},
				},
				{
					alias: 'thumb_fallback',
					config: {
						width: 888,
						height: 324,
						crop: false,
					},
				},
			],
		},	
		promotion: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 960,
						height: 676,
						crop: true,
					},
				},	
			],
		},
		cart: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 400,
						height: 400,
						crop: false,
					},
				},
			],
		},
		cartPackage: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 64,
						height: 64,
						crop: false,
					},
				},
			],
		},
		landingIntroImage: {
			imageFields: ['image', 'image2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1440,
						height: 528,
						crop: true,
					},
					related: ['image']
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 960,
						height: 676,
						crop: true,
					},
					related: ['image2']
				},
			],
		},
		landingPublish: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1440,
						height: 530,
						crop: true,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 960,
						height: 676,
						crop: true,
					},
				},
			],
		},
		landingCoupon: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 720,
						height: 550,
						crop: true,
					},
				},
			],
		},
		landingImage: {
			imageFields: ['image', 'image2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1920,
						height: 800,
						crop: false,
					},
				},
				{
					alias: 'thumb_icon',
					config: {
						width: 150,
						height: 60,
						crop: false,
					},
				},
			],
		},
		landingImagePromo: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1110,
						height: 600,
						crop: true,
					},
				},
			],
		},
		landingPromo2: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1057,
						height: 540,
						crop: true,
					},
				},
			],
		},
		landingPromo3: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 850,
						height: 530,
						crop: true,
					},
				},
			],
		},
		landingPromo4: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 510,
						height: 262,
						crop: true,
					},
				},
			],
		},
		landingPromoBig: {
			imageFields: ['image', 'image2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1480,
						height: 1480,
						crop: false,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 760,
						height: 760,
						crop: false,
					},
				},
			],
		},
		landingPromoMedium: {
			imageFields: ['image', 'image2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 760,
						height: 760,
						crop: false,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 760,
						height: 760,
						crop: false,
					},
				},
			],
		},
		landingPromoSmall: {
			imageFields: ['image', 'image2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 720,
						crop: false,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 1140,
						height: 1140,
						crop: false,
					},
				},
			],
		},
		landingImageProduct: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 480,
						height: 480,
						crop: false,
					},
				},
			],
		},
		servicesCategory: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1440,
						height: 530,
						crop: true,
					},
				},
				{
					alias: 'thumb_small',
					config: {
						width: 480,
						height: 220,
						crop: true,
					},
				},
			],
		},
		publishSpecialServices: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 480,
						height: 220,
						crop: true,
					},
				}
			],
		},
		promoCatalog: {
			imageFields: ['image', 'image_2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1480,
						height: 540,
						crop: true,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 724,
						height: 380,
						crop: true,
					},
				},
			],
		},
		landingPromo: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1428,
						height: 696,
						crop: true,
					},
				},
				{
					alias: 'thumb_square',
					config: {
						width: 696,
						height: 696,
						crop: true,
					},
				},
			],
		},
		promoCatalogSpecial: {
			imageFields: ['image', 'image_2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1920,
						height: 200,
						crop: true,
					},
					related: ['image']
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 1200,
						height: 628,
						crop: true,
					},
					related: ['image_2']
				},
			],
		},
		promoFeaturedRotator: {
			imageFields: ['image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 533,
						height: 270,
						crop: true,
					},
				},
			],
		},
		promoDoubleRotator: {
			imageFields: ['image_upload_path'],
			thumbs: [
				{
					alias: 'banner',
					config: {
						width: 403,
						height: 715,
						crop: true,
					},
				},
				{
					alias: 'thumb',
					config: {
						width: 403,
						height: 339,
						crop: true,
					},
				},
			],
		},
		comment: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 100,
						height: 100,
						crop: false,
					},
				},
			],
		},
		order: {
			imageFields: ['main_image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 140,
						height: 140,
						crop: false,
					},
				},
			],
		},	
		faqCategories: {
			imageFields: ['main_image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 600,
						height: 340,
						crop: true,
					},
				},
			],
		},	
	}
});
